module.exports = "<svg viewBox=\"0 0 10 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"10\" height=\"2\" fill=\"#474747\"></rect></svg>"